// extracted by mini-css-extract-plugin
module.exports = {"Statistics":"Statistics_Statistics__3W6zh","Container":"Statistics_Container__FgpZ9","Stats":"Statistics_Stats__3G2nm","Ver":"Statistics_Ver__3d9ty"};